/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-expansion-panel-header[_ngcontent-%COMP%], form[_ngcontent-%COMP%]{position:relative;margin:auto;width:96%}div.mat-expansion-panel-body[_ngcontent-%COMP%]{padding:0}.mat-expansion-panel-header-title[_ngcontent-%COMP%]{position:absolute;font-weight:600;min-width:111px;top:5px}p[_ngcontent-%COMP%]{margin-bottom:0}\n/*# sourceMappingURL=issue-filter.component.css.map*/"];
export { styles as styles };
